import CollectGraphicsPreviewBlock from "./collect-graphics-preview-block";
import CollectGraphicsInfoBlock from "./collect-graphics-info-block";
import CollectGraphicsCommentBlock from "./collect-graphics-comment-block";

import "./collect-graphics-blocks.scss";

const CollectGraphicsBlocks = {
    Preview: CollectGraphicsPreviewBlock,
    Info: CollectGraphicsInfoBlock,
    Comment: CollectGraphicsCommentBlock
};

export default CollectGraphicsBlocks;